import { render, staticRenderFns } from "./DistrictSearch.vue?vue&type=template&id=6387e45e&scoped=true"
import script from "./DistrictSearch.vue?vue&type=script&lang=js"
export * from "./DistrictSearch.vue?vue&type=script&lang=js"
import style0 from "./DistrictSearch.vue?vue&type=style&index=0&id=6387e45e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6387e45e",
  null
  
)

export default component.exports